import moment from 'moment';

import Form from './Form';
import type { Rules, FieldLabels, ErrorMessages } from '../types/form';

export type UserFormInput = {
  first_name?: string,
  last_name?: string,
  dob?: string,
  insurance_number?: string,
  phone?: string,
  region_id?: number
};

export default class UserForm extends Form {
  get keys(): Array<string> {
    return ['first_name', 'last_name', 'dob', 'insurance_number', 'phone', 'region_id'];
  }

  get rules(): Rules {
    return {
      first_name: (input: string) => input.length > 1,
      last_name: (input) => input.length > 1,
      dob: (input) => moment(moment(new Date()).diff(new Date(input), 'years', true)) >= 18,
      region_id: (input) => !!input
    };
  }

  translatedValue = (key: String) => this.getTranslatedValue('profileForm', key);

  get errorMessages(): ErrorMessages {
    return {
      first_name: this.translatedValue('errors.first_name'),
      last_name: this.translatedValue('errors.last_name'),
      dob: this.translatedValue('errors.dob'),
      region_id: this.translatedValue('errors.region_id')
    };
  }

  get fieldLabels(): FieldLabels {
    return {
      first_name: this.translatedValue('first_name'),
      last_name: this.translatedValue('last_name'),
      dob: this.translatedValue('dob'),
      insurance_number: this.translatedValue('insurance_number'),
      phone: this.translatedValue('phone'),
      region_id: this.translatedValue('region_id')
    };
  }
}



// WEBPACK FOOTER //
// ./src/models/ProfileForm.js